import React from 'react'
import './Inicio.css'
import RotatingText from '../RotatingText/RotatingText'

function Inicio() {
    return (
        <div className='hero'>
            <video
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                poster="/media/inicio.jpg"
                className="hero__video"
            >
                <source src="/media/inicio.mp4" type="video/mp4" />
            </video>

            <div className="hero__overlay" />
            <div className="hero__grain" />

            <div className="hero__content">
                <div className="hero__row">
                <div className='logo'>
                    <img className='logoUno' src="/img/drontalia1.png" alt="logo" />
                    <div className="izq">
                        <span className='word'>DRONTALIA</span>
                    </div>
                </div>
                <h1 className='titulo'>
                    <RotatingText
                        texts={['FIABILIDAD', 'PRECISIÓN', 'EFICIENCIA', 'INNOVACIÓN']}
                        mainClassName="px-2 sm:px-2 md:px-3 bg-cyan-300 text-black overflow-hidden py-0.5 sm:py-1 md:py-2 justify-center rounded-lg"
                        staggerFrom={"last"}
                        initial={{ y: "100%" }}
                        animate={{ y: 0 }}
                        exit={{ y: "-120%" }}
                        staggerDuration={0.025}
                        splitLevelClassName="overflow-hidden pb-0.5 sm:pb-1 md:pb-1"
                        transition={{ type: "spring", damping: 30, stiffness: 400 }}
                        rotationInterval={2000}
                    />
                </h1>
                </div>
            </div>

            <div className="hero__scroll">
                <span className="hero__scrollLabel">SCROLL</span>
                <span className="hero__scrollLine" />
            </div>
        </div>
    )
}

export default Inicio
